import { blue50, blue60 } from '../../../colors/blue';
import { gray40 } from '../../../colors/gray';
import { neutral60opacity20 } from '../../../colors/neutral';
export var MuiSlider = {
    defaultProps: { size: 'small' },
    styleOverrides: {
        root: {
            '&[class*=Mui-disabled]': { color: blue50, opacity: 0.5 },
        },
        thumb: {
            '&:hover': {
                backgroundColor: blue60,
                boxShadow: 'none',
            },
            '&[class*=Mui-focusVisible]': {
                backgroundColor: blue50,
                boxShadow: "0 0 0 2px ".concat(blue60),
            },
        },
        mark: {
            backgroundColor: gray40,
        },
        rail: {
            backgroundColor: neutral60opacity20,
        },
    },
};
